---
id: go-shared-errs
title: Shared error helpers
owner: Backend Team
status: Active
lastReviewed: 2026-01-30
visibility: internal
tags:
  - errors
  - shared
  - http
---

## Product Overview

### Who it serves

This shared package standardizes error responses for Go services so callers and clients can rely on consistent status codes and messages.

### Primary workflow

Service code constructs typed errors using the helper constructors, and those errors propagate through handlers and documentation tooling.

### Business rules

Errors map to HTTP status codes with consistent messages to keep API behavior aligned across services.

### Outcomes

Teams get predictable error structures for API responses and OpenAPI documentation examples.

### Out of scope

Service-specific error messaging and localization are handled by the calling services.

## Technical Overview

### Architecture flow

`ReziError` wraps HTTP status metadata and optional causes, while constructors like `NewBadRequest` and `NewUnauthorized` create standard errors used by handlers.

### Entry points

The main entry points are the `ReziError` type and constructors in `apps/micro-services/go-shared/errs/errs.go`, plus the `ErrorExamples` map used by documentation generation.

### Key modules

`errs.go` defines reusable error instances, constructors, and the OpenAPI-friendly `ErrorExamples` map.

### Data sources and sinks

Errors flow through HTTP handlers and the shared document builder, which reads `ErrorExamples` to populate error responses.

### Integrations and side effects

This package integrates with the shared document builder and handler layers to ensure uniform error response metadata.

### Constraints and risks

If error messages drift across services, documentation and client expectations may become inconsistent.

## Changelog

- 2026-01-30: Initial documentation.
